export default (() => /test=/.test(window.location.search) || /preview=/.test(window.location.search));